<app-common-header></app-common-header>
<main role="main" class="maincnt quest">
  <div class="getbannersect pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0">
        <div class="col-12 text-center webview">
          <!-- <div style="background-color: White"> -->
            <!-- <img src="assets/images/eva-icons.svg" class="signimg"/> -->
          <!-- </div> -->
        </div>
        <div class="col-sm-12 p-0" [ngClass]="{ 'mt-5': IsWeb }">
          <a href="javascript:void(0)" *ngIf="showBack" class="backbtn webview" (click)="back();"></a>
          <div id ="container">
            <ng-template appResidential></ng-template>
          </div>
        </div>
        <!-- <div class="col-sm-8 p-0 mt-5 pb-4 mobileview">
          <div class="text-center col-10 m-auto">
            <ng-template appResidential></ng-template>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</main>

<!--For Renewal-->
<div *ngIf="questionFlowType === 'renewal'" class="btm-process webview">
  <div class="text-center">
    <span><img src="assets/images/activetower.png" style="margin-top:0px !important;"></span>
    <span class="active"><img src="assets/images/activethunder.png" id="thunder001"></span>
    <span class="active"><img src="assets/images/activedot.png" id="dot002"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0014"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0016"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0017"></span>
    <span class="disableimg" *ngIf="selectedServiceType === 'Switching Providers'"><img src="assets/images/disabledot.png" id="dot0018"></span>
    <span class="disableimg" *ngIf="selectedServiceType === 'New Service'"><img src="assets/images/disabledot.png" id="dot0019"></span>
    <span class="disableimg thunder" *ngIf="selectedServiceType === 'Switching Providers'"><img src="assets/images/disablethunder.png" id="thunder0020"></span>
    <span class="disableimg thunder" *ngIf="selectedServiceType === 'New Service'"><img src="assets/images/disablethunder.png" id="thunder0021"></span>
    <span class="disableimg" *ngIf="selectedServiceType === 'Switching Providers'"><img src="assets/images/disabledot.png" id="dot0022"></span>
    <span class="disableimg" *ngIf="selectedServiceType === 'New Service'"><img src="assets/images/disabledot.png" id="dot0023"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0024"></span>
    <span class="disableimg"><img src="assets/images/disablehome.png" id="home"></span>
    <!-- <h4 class="clr333 processtxt">{{percentage}}% Completed</h4> -->
  </div>
</div>

<div *ngIf="questionFlowType !== 'renewal' && selectedServiceType === 'New Service'" class="btm-process webview">
  <div class="text-center">
    <span><img src="assets/images/activetower.png" style="margin-top:0px !important;"></span>
    <span class="active"><img src="assets/images/activethunder.png" id="thunder001"></span>
    <span class="active"><img src="assets/images/activedot.png" id="dot002"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot007"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot008"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot009"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0010"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0011"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0012"></span>
    <span class="disableimg" *ngIf="showOwn"s><img src="assets/images/disabledot.png" id="dot0013"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0014"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0015"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0016"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0017"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0019"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0021"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0023"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0024"></span>
    <span class="disableimg"><img src="assets/images/disablehome.png" id="home"></span>
    <span *ngIf="showPrepaid" class="disableimg"><img src="assets/images/disablehome.png" id="home"></span>
    <!-- <h4 class="clr333 processtxt">{{percentage}}% Completed</h4> -->
  </div>
</div>
<div class="btm-process webview" *ngIf="questionFlowType !== 'renewal' && selectedServiceType !== 'New Service'">
  <div class="text-center">
    <span><img src="assets/images/activetower.png" style="margin-top:0px !important;"></span>
    <span *ngIf="!showThunder"><img src="assets/images/disablethunder.png" id="thunder001"></span>
    <span *ngIf="showThunder"><img src="assets/images/activethunder.png" id="thunder001"></span>
    <span *ngIf="selectedServiceType !== 'Switching Providers'"><img src="assets/images/disabledot.png" id="dot002"></span>
    <span *ngIf="selectedServiceType === 'Switching Providers'"><img src="assets/images/activedot.png" id="dot002"></span>
    <span><img src="assets/images/disabledot.png" id="dot003"></span>
    <span><img src="assets/images/disabledot.png" id="dot004"></span>
    <span *ngIf='showNextId'>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot008"></span>
      <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder009"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0010"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0011"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0012"></span>
      <span class="disableimg" *ngIf="showOwn"><img src="assets/images/disabledot.png" id="dot0013"></span>
      <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0014"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0015"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0016"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0017"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0018"></span>
      <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0020"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0022"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0024"></span>
      <!-- <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0025"></span> -->
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0026"></span>
      <span *ngIf="showPrepaid" class="disableimg"><img src="assets/images/disabledot.png" id="dot0027"></span>
      <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0028"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0029"></span>
      <!-- <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0030"></span> -->
      <span class="disableimg"><img src="assets/images/disablehome.png" id="home"></span>
    </span>
    <span *ngIf='!showNextId'>
      <!-- <span class="disableimg"><img src="assets/images/disabledot.png" id="dot005"></span> -->
      <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder005"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot008"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot009"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0010"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0011"></span>
      <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0012"></span>
      <span class="disableimg" *ngIf="showOwn"><img src="assets/images/disabledot.png" id="dot0013"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0014"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0015"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0016"></span>
      <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0017"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0018"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0020"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0022"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0024"></span>
      <!-- <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0025"></span> -->
      <span class="disableimg"><img src="assets/images/disablethunder.png" id="dot0026"></span>
      <span *ngIf="showPrepaid" class="disableimg"><img src="assets/images/disabledot.png" id="dot0027"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0028"></span>
      <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0029"></span>
      <!-- <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0030"></span> -->
      <span class="disableimg"><img src="assets/images/disablehome.png" id="home"></span>
    </span>
    <!-- <h4 class="clr333 processtxt text-muted">{{percentage}}% Completed</h4> -->
  </div>
</div>

<ng-template #template class="card-popup">
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0">
      <!-- <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="closeModalWithOutContact()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button> -->
    </div>
  </div>
  <div class="modal-body">
    <h4 *ngIf="!ShowError" class="utility-modal-title text-center font20  mb-3">
      How would you like to shop for your nest electricity plan?
    </h4>
    
    <div *ngIf="!ShowError" class="row  gx-4"> 
      
        <div class="col-sm-6 mb-2 ">
         <div (click)="Redirect('Ques')" class="card text-center  options-card">
            <img src="assets/images/frame06.jpg" />
            <p class="fw-bold" style="font-size: 19px;"> 
              Help Me Choose
            </p>
            <div class="Poptext fw-bold"><p>Take a brief survey to find the best plan for you. (~5 mins) </p></div>
            <p class="fw-bold">if you need some help shopping, choose this. </p>
            <input
            class=""
            id="confirm1"
            name="property"
            style="height: 22px;"
            type="checkbox"
            value="confirm"
            [ngx-scroll-to]="'#prodPreference'"
            [ngx-scroll-to-duration]="10"
            (click)="Redirect('Ques')"
          />
      
          </div>
      </div>
        <div class="col-sm-6 mb-2" > 
          <div   (click)="Redirect('Plans')" class="card text-center options-card">
            <img src="assets/images/frame02.png" />
            <p class="fw-bold" style="font-size: 19px;"> 
              Get Pricing
            </p>
            <div class="Poptext fw-bold"><p>Quickly compare pricing from {{PlanCount}} plans on your own. </p></div>
            <p class="fw-bold">If you know how to find what you’re looking for, select this. </p>
            <input
            class=""
            id="confirm1"
            style="height: 22px;"
            name="property"
            type="checkbox"
            value="confirm"
            [ngx-scroll-to]="'#prodPreference'"
            [ngx-scroll-to-duration]="10"
            (click)="Redirect('Plans')"
          />
        </div>
      </div>
    </div>
 

    
    <h4 *ngIf="ShowError" class="utility-modal-title font20 text-center mb-3">
      <div>{{ErrorMsg}}</div>
    </h4>
  

    <br />

  </div>
</ng-template>